import React from "react";
import PropTypes from "prop-types";
import Base from "../Base";
import MaterialIcon from "components/common/MaterialIcon";
import { Input } from "antd";

@autobind
/**
 *
 */
export default class Password extends Base {
  static propTypes = {
    ...Base.propTypes,
    value: PropTypes.string,
  };

  /**
   *
   * @param {Object} props
   */
  constructor(props) {
    super(props);

    this.state = {
      view: false,
    };
  }

  /**
   *
   * @return {XML}
   * @protected
   */
  get _component() {
    const { view } = this.state;
    const { rest } = this.props;

    return (
      <Input
        className="redux-password"
        type={view ? "text" : "password"}
        dir="auto"
        {...rest}
        suffix={
          <MaterialIcon
            name={view ? "eye-off" : "eye"}
            size="tiny"
            disabled={this.props.disabled}
            onClick={() => this.setState({ view: !view })}
          />
        }
      />
    );
  }
}
